import React, { useState, useEffect } from 'react';
import { Button, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Modal from "../../../components/safe-modal/SafeModal.jsx";
import ProgressChart from '../Charts/ProgressChar';

const ChildsModal=({toggle,setToggle,data,cycle})=> {
   
   
    return ( 
        <Modal isOpen={toggle} backdrop="static"   centered={true}  size="xl ">
                <ModalHeader toggle={()=>setToggle()}></ModalHeader>
                <ModalBody>
                    <ProgressChart dataChart={data}  cycle={cycle} />
                
                </ModalBody>
                
                <ModalFooter>
                
                <Button color="secondary" onClick={()=>setToggle()}>
                    Cerrar
                </Button>
                </ModalFooter>
        </Modal>
     );
}

export default ChildsModal;